import React, { createContext, useEffect, useState, useRef } from "react";
import axiosConfig from "../util/axiosConfig";
import { studentsDomain } from "../util/domain";

const UserContext = createContext();

function UserContextProvider(props) {
  const [user, setUser] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);





  async function getUser() {
    try {
      const userRes = await axiosConfig.get(`/auth/loggedIn`);
      if (userRes.data) {
        setUser(userRes.data);
        // Update localStorage with latest user data
        localStorage.setItem('user', JSON.stringify(userRes.data));
      } else {
        setUser(null);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } catch (error) {
      console.error('Get user error:', error);
      setUser(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } finally {
      setIsLoading(false);
    }
  }

  async function logoutUser() {
    try {
      setIsLoading(true);
      // Clear browser storage
      localStorage.clear();
      sessionStorage.clear();

      // Clear cookies by making the logout request
      await axiosConfig.get(`/auth/logOut`);

      // Reset user state
      setUser(null);


      // Clear any remaining cookies manually
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    } catch (error) {
      console.error('Logout error:', error);
      // Still clear all data even if API call fails
      localStorage.clear();
      sessionStorage.clear();
      setUser(null);


      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const initializeAuth = async () => {
      // 1) Check URL parameters for token and user
      try {
        const params = new URLSearchParams(window.location.search);
        const urlToken = params.get('token');
        const urlUser = params.get('user');

        if (urlToken) {
          localStorage.setItem('token', urlToken);
        }

        if (urlUser) {
          try {
            const decoded = decodeURIComponent(urlUser);
            const parsedUser = JSON.parse(decoded);
            localStorage.setItem('user', JSON.stringify(parsedUser));
          } catch (e) {
            // If not URI encoded, try direct JSON parse
            try {
              const parsedUser = JSON.parse(urlUser);
              localStorage.setItem('user', JSON.stringify(parsedUser));
            } catch (e2) {
              // Ignore malformed user payload
            }
          }
        }

        // If we consumed URL auth params, clean them from the URL bar
        if (urlToken || urlUser) {
          const cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      } catch (e) {
        // swallow URL parsing errors
      }

      const token = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');

      if (token && storedUser) {
        // First set the stored user data to avoid loading state
        setUser(JSON.parse(storedUser));
        setIsLoading(false);
        // Then verify the token in the background
        getUser();

      } else {
        setUser(null);
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []);



  return (
    <UserContext.Provider value={{
      user,
      getUser,
      logoutUser,
      isLoading,
      setUser,
    }}>
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;
export { UserContextProvider };
